import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { configService } from '../../services';
import { PrescriptionAPIConfig } from '../../types';
import './APIConfigPage.css';

const { TextArea } = Input;

const APIConfigPage: React.FC = () => {
  const [form] = Form.useForm();
  const queryClient = useQueryClient();

  const { data: config, isLoading } = useQuery({
    queryKey: ['prescription-api-config'],
    queryFn: () => configService.getPrescriptionAPIConfig(),
  });

  const saveMutation = useMutation({
    mutationFn: (values: PrescriptionAPIConfig) => configService.savePrescriptionAPIConfig(values),
    onSuccess: () => {
      message.success('Lưu thông tin thành công!');
      queryClient.invalidateQueries({ queryKey: ['prescription-api-config'] });
    },
    onError: () => {
      message.error('Lưu thông tin thất bại!');
    },
  });

  useEffect(() => {
    if (config) {
      form.setFieldsValue(config);
    }
  }, [config, form]);

  const onFinish = (values: any) => {
    saveMutation.mutate(values);
  };

  return (
    <div className="api-config-page">
      <h1 className="page-title">Cấu hình API toa thuốc</h1>

      <Card>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={config}
        >
          <Form.Item
            name="serverId"
            label="Server ID"
            rules={[{ required: true, message: 'Vui lòng nhập Server ID!' }]}
          >
            <Input placeholder="Nhập Server ID" />
          </Form.Item>

          <Form.Item
            name="code"
            label="Code"
            rules={[{ required: true, message: 'Vui lòng nhập Code!' }]}
          >
            <Input placeholder="Nhập Code" />
          </Form.Item>

          <Form.Item
            name="timestamp"
            label="Timestamp"
            rules={[{ required: true, message: 'Vui lòng nhập Timestamp!' }]}
          >
            <Input placeholder="Nhập Timestamp" />
          </Form.Item>

          <Form.Item
            name="signature"
            label="Signature"
            rules={[{ required: true, message: 'Vui lòng nhập Signature!' }]}
          >
            <TextArea
              rows={8}
              placeholder="Nhập Signature (Encrypted Private Key)"
            />
          </Form.Item>

          <Form.Item name="notes" label="Ghi chú">
            <TextArea rows={4} placeholder="Nhập ghi chú (nếu có)" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              icon={<SaveOutlined />}
              loading={saveMutation.isPending}
            >
              Lưu thông tin
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default APIConfigPage;

